import { NAME_SPACE } from './constants';

export const OPEN = `${NAME_SPACE} OPEN`;
export const CLOSE = `${NAME_SPACE} CLOSE`;
